import React from "react";
import { ReportCountAuthorGroup  } from "../../features/reportmanagementsummary";
import { ClientReportManagementFilterSubHeader } from "../../layouts/ClientReportManagementLayout";

const SummaryByAuthorPage = () => (
    <React.Fragment>
        <ClientReportManagementFilterSubHeader />
        <section className="px-4 my-3 h-100">
            <ReportCountAuthorGroup />
        </section>
    </React.Fragment>
);

export default SummaryByAuthorPage;